import { c as _c } from "react/compiler-runtime";
/* eslint-disable */

import { useEffect } from "react";
import { useEcomStore } from "@/context/ecom/EcomContext";
const useAccountConfirmation = () => {
  const $ = _c(11);
  const [state, dispatch] = useEcomStore() ?? [null, _temp];
  let t0;
  if ($[0] !== dispatch || $[1] !== state?.accounts || $[2] !== state?.activeAccount?.role || $[3] !== state?.isAccountConfirmationRequired || $[4] !== state?.isAccountConfirmed) {
    t0 = () => {
      if (Array.isArray(state?.accounts)) {
        const isValidEcomAccount = state?.activeAccount?.role === "ACCOUNT_OWNER" || state?.activeAccount?.role === "SECONDARY_ACCOUNT_OWNER";
        if (!state?.isAccountConfirmed || !isValidEcomAccount) {
          const purchasingAccounts = state?.accounts.filter(_temp2);
          const isAccountChoiceRequired = purchasingAccounts?.length > 1;
          const isAccountSwitchRequired = !isValidEcomAccount && purchasingAccounts?.length > 0;
          if (isAccountChoiceRequired || isAccountSwitchRequired) {
            if (!state?.isAccountConfirmationRequired) {
              dispatch({
                type: "SET_ACCOUNT_CONFIRMATION_REQUIRED",
                payload: true
              });
            }
          } else {
            if (!state?.isAccountConfirmed) {
              dispatch({
                type: "SET_ACCOUNT_CONFIRMED",
                payload: true
              });
            }
          }
        }
      }
    };
    $[0] = dispatch;
    $[1] = state?.accounts;
    $[2] = state?.activeAccount?.role;
    $[3] = state?.isAccountConfirmationRequired;
    $[4] = state?.isAccountConfirmed;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const t1 = state?.accounts;
  const t2 = state?.activeAccount;
  const t3 = state?.isAccountConfirmed;
  const t4 = state?.isAccountConfirmationRequired;
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = [t1, t2, t3, t4];
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t0, t5);
};
export default useAccountConfirmation;
function _temp() {
  console.warn("Dispatch called but store not available");
}
function _temp2(account) {
  return account?.role === "ACCOUNT_OWNER" || account?.role === "SECONDARY_ACCOUNT_OWNER";
}